export default {"src":"/_next/static/media/prev.c937e36e.svg","height":14,"width":8};